var Backbone, EmailFormFileInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormFileInputView = (function(superClass) {
  extend(EmailFormFileInputView, superClass);

  function EmailFormFileInputView() {
    return EmailFormFileInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormFileInputView.prototype.tagName = 'li';

  EmailFormFileInputView.prototype.events = {
    'change #fileupload': 'getFileData',
    'click #file_reset': 'resetFileInput'
  };

  EmailFormFileInputView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.elementID = "#email_file_input";
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.required = this.model.required === true || this.model.required === "true";
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    this.I18nScope = 'modules.support';
    this.template = this.options.template;
    return this.resetFileData();
  };

  EmailFormFileInputView.prototype.render = function() {
    return this.$el.html(toHtml(this.template, this.toHash()));
  };

  EmailFormFileInputView.prototype.toHash = function() {
    return {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      file_input_template: this.isFileUploadEnabled(),
      label: this.label,
      required: this.isInputCompulsory,
      counter: this.model.counter
    };
  };

  EmailFormFileInputView.prototype.isInputGiven = function() {
    return this.fileData !== null || (!this.isFileUploadEnabled());
  };

  EmailFormFileInputView.prototype.isFileUploadEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.fileUpload : void 0);
  };

  EmailFormFileInputView.prototype.isInputValid = function() {
    return this.validateFileInput();
  };

  EmailFormFileInputView.prototype.validateFileInput = function() {
    var acceptedFormats, err_msg, file, fileFormat, fileSize, fileUploadHtmlElement, maxSize, ref;
    fileUploadHtmlElement = this.getFileInput();
    if ((fileUploadHtmlElement != null ? (ref = fileUploadHtmlElement.files) != null ? ref.length : void 0 : void 0) > 0) {
      file = fileUploadHtmlElement.files[0];
    }
    if (file != null) {
      this.fileName = file.name;
      fileFormat = this.getFileFormat();
      fileSize = file.size;
      acceptedFormats = ['jpg', 'jpeg', 'gif', 'bmp', 'png', 'pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt', 'csv', 'tiff'];
      maxSize = 1000000;
      if (($.inArray(fileFormat, acceptedFormats) >= 0) && fileSize < maxSize) {
        this.$(".error_upload").text("");
        return true;
      } else {
        err_msg = I18n.translate('js.modules.support.invalid_file_message', {
          acceptedFormats: "" + acceptedFormats,
          max_size: 1
        });
        this.$(".error_upload").text(err_msg);
        return false;
      }
    } else {
      return true;
    }
  };

  EmailFormFileInputView.prototype.renderErrorUpload = function() {
    return $(".error_upload").text('Error uploading file');
  };

  EmailFormFileInputView.prototype.removeUploadError = function() {
    return $(".error_upload").text('');
  };

  EmailFormFileInputView.prototype.showFileReset = function() {
    return this.$('#file_reset').show();
  };

  EmailFormFileInputView.prototype.hideFileReset = function() {
    return this.$('#file_reset').hide();
  };

  EmailFormFileInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory) {
      return this.options.validateEmailForm();
    }
  };

  EmailFormFileInputView.prototype.resetFileInput = function() {
    var fileControl;
    fileControl = $('.fileupload');
    if ((fileControl != null ? fileControl.length : void 0) > 0) {
      fileControl.wrap('<form>').closest('form').get(0).reset();
      fileControl.unwrap();
    }
    this.resetFileData();
    this.hideFileReset();
    return this.validateEmailForm();
  };

  EmailFormFileInputView.prototype.getFileData = function(e) {
    var reader, ref, ref1, ref2;
    if (((ref = this.getFileInput()) != null ? (ref1 = ref.files) != null ? ref1.length : void 0 : void 0) > 0) {
      this.showFileReset();
      reader = new FileReader();
      reader.onloadend = this.getFileText;
      reader.onerror = this.renderErrorUpload;
      return reader.readAsDataURL((ref2 = this.getFileInput()) != null ? ref2.files[0] : void 0);
    } else {
      this.resetFileData();
      return this.hideFileReset();
    }
  };

  EmailFormFileInputView.prototype.getFileFormat = function() {
    return this.fileName.split(".")[this.fileName.split(".").length - 1].toLowerCase();
  };

  EmailFormFileInputView.prototype.getFileName = function() {
    var filename, fullPath, ref, startIndex;
    fullPath = (ref = this.getFileInput()) != null ? ref.value : void 0;
    startIndex = (fullPath.indexOf("\\") >= 0 ? fullPath.lastIndexOf("\\") : fullPath.lastIndexOf("/"));
    filename = fullPath.substring(startIndex);
    if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
      return filename.substring(1);
    }
  };

  EmailFormFileInputView.prototype.getFileText = function(e) {
    this.fileData = e.target.result;
    this.fileName = this.getFileName();
    return this.validateEmailForm();
  };

  EmailFormFileInputView.prototype.resetFileData = function() {
    this.fileData = null;
    return this.fileName = null;
  };

  EmailFormFileInputView.prototype.getFileInput = function() {
    return document.getElementById('fileupload');
  };

  EmailFormFileInputView.prototype.populateInput = function(data) {
    data.fileData = this.fileData;
    return data.fileName = this.fileName;
  };

  return EmailFormFileInputView;

})(Backbone.View);

module.exports = EmailFormFileInputView;

//# sourceMappingURL=data:application/json;base64,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
